import { FormControlLabel, Switch } from "@mui/material";
import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from "react-hook-form";

interface Props<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label: string;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

export const SwitchWithControl = <T extends FieldValues>({
  control,
  name,
  label,
  disabled,
  onChange,
}: Props<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormControlLabel
            {...field}
            onChange={(_, checked) => {
              field.onChange(checked);
              if (onChange) onChange(checked);
            }}
            disabled={disabled}
            control={<Switch checked={field.value} disabled={disabled} />}
            label={label}
          />
        );
      }}
    />
  );
};
